import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import SidebarRow from './SidebarRow';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsConsent, setIsConsentPopupOpened, setIsLanguagePopupOpened, setIsSettingsPopupOpened, setIsNoteTypePopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const Settings: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const { consultationId } = useParams();
    const colors = useAppSelector(state => state.theme.colors);
    const language = useAppSelector(state => state.consultation.language);
    const noteType = useAppSelector(state => state.consultation.noteType);
    const isConsent = useAppSelector(state => state.consultation.isConsent);

    useEffect(() => {
        if (language && i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [language, i18n]);

    const goToSettings = () => {
        dispatch(setIsSettingsPopupOpened(true));
    };

    const handleConsent = async () => {
        if (isConsent) {
            const content = { consultationId, isConsentRemoved: true };
            updateConsultation(content);
            dispatch(setIsConsent(false));
            dispatch(setNotificationMessage(t('patientConsentDisabled')));
        } else {
            dispatch(setIsConsentPopupOpened(true));
        }
    };

    const handleLanguageSelection = async () => {
        dispatch(setIsLanguagePopupOpened(true));
    };

    const handleNoteTypeSelection = async () => {
        dispatch(setIsNoteTypePopupOpened(true));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', padding: '8px 0', backgroundColor: colors?.container, fontSize: 14 }}>
            <SidebarRow
                title='patientConsent'
                icon={<PersonPinOutlinedIcon sx={{ color: colors?.main }} />}
                handler={handleConsent}
                extraIcon={isConsent ? <ToggleOnIcon sx={{ color: colors?.main }} /> : <ToggleOffOutlinedIcon sx={{ color: colors?.main }} />}
            />
            <SidebarRow
                title='language'
                icon={<PublicOutlinedIcon sx={{ color: colors?.main }} />}
                handler={handleLanguageSelection}
                extraIcon={<Box sx={{ color: 'rgb(150, 150, 150)' }}>{t(language)}</Box>}
            />
            <SidebarRow
                title='noteType'
                icon={<DescriptionOutlinedIcon sx={{ color: colors?.main }} />}
                handler={handleNoteTypeSelection}
                // FIX: Display the 'name' property from the noteType object
                extraIcon={<Box sx={{ color: 'rgb(150, 150, 150)' }}>{noteType ? noteType.name : '...'}</Box>}
            />
            <SidebarRow
                title='microphone'
                icon={<MicNoneOutlinedIcon sx={{ color: colors?.main }} />}
                extraIcon={<Box sx={{ color: 'rgb(150, 150, 150)' }}>{'Default'}</Box>}
                isDisabled
            />
            <SidebarRow
                title='settings'
                icon={<SettingsOutlinedIcon sx={{ color: colors?.main }} />}
                handler={goToSettings}
                extraIcon={<KeyboardArrowRightIcon sx={{ color: colors?.main }} />}
            />
        </Box>
    );
};

export default Settings;